<template>
  <div style="width: 100%;" v-loading.fullscreen.lock="loading">
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;" v-loading.fullscreen.lock="loading">
        <el-form ref="form" label-width="100px" >
          <el-row>
            <el-col :span="9">
              <el-form-item :label="$t('field.demandDate')">
                <el-col :span="11">
                  <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="sdate" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="2" style='text-align: center;'>-</el-col>
                <el-col :span="11">
                <el-date-picker type="date" :placeholder="$t('msg.selectDate')" v-model="edate" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="FAE">
                <el-select v-model="fae" :placeholder="$t('msg.pleaseSelect')" clearable >
                  <el-option v-for="item in faeOpts"  :key="item.value"  :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <CustomerSearch v-if="!isCustomer" v-model="custSapCode"  @sync-select-customer="syncSelectCustomer" /> 
            </el-col>    
          </el-row>  
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
              <el-button type="success" @click="createTraining"  size="small">{{$t('button.apply')}}</el-button>          
              <el-button type="warning" @click="descOpen"  size="small">{{$t('button.trainingOutline')}}</el-button>
              <el-button type="warning" @click="downloadTutorial"  size="small">{{$t('button.trainingDescription')}}</el-button>

            </el-col>             
          </el-row>   
        </el-form>
        <el-row>  
          <!--Table ref="table1" :tableData="tableData" :linkAction="linkAction"/--> 
          <Table ref="tableList" :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="false" :showEditButton="true"  
                :showCreate="false" @sync-delete="deleteDoc" @sync-save="saveDoc" @sync-file-status="saveFileSuccess" @reload-data-by-sort="reloadDataBySort" :checkAction="checkAction" 
                @special-click="sendMail" @edit-click="changeFaeData" @sync-cancel="cancelSave"/> 
        </el-row>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" >     
          <img src="..//..//assets/training_item_desc.png" style=" max-height: 100%; max-width: 100%; "/>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">{{$t('button.confirm')}}</el-button>
          </span>
        </el-dialog>
    </el-main>
  </div>
</template>

<script>
import CustomerSearch from "../components/CustomerSearch";
import Table from '../components/EditableTableWithFile'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindTrainingByCondition, apiTrainingSave, apiTrainingDeleteById, apiFindCustIncxWindowsForFae, apiFindSysValueByCategory, apiFaeClosed,
        apiFindCustIncxWindowsForFaeByCustSapCode, apiSendTrainingMail, apiCreateTraining } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import AWSUtil from "../../utils/AWSUtil";

const AWS = require('aws-sdk')

AWS.config.update({
  region: AWSUtil.getBucketRegion(),
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AWSUtil.getIdentityPoolId()
  })
});
var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: AWSUtil.getAlbumBucketName() },
  httpOptions: {
		timeout: 30*1000*60,
	},
});
  
export default {
  name: 'trainingFae',
  data() {    
    return { 
      loading:false, 
      addDataSuccess: false,   
      sdate: '',
      edate: '',
      fae: '',
      faeOpts:[],
      isCustomer:false,
      custSapCode:'',
      sortColumn:'',
      sortType:'',   
      tableData: {
        sel: null,   
        columns: [
          { field: "applyDateStr", title:this.$i18n.t('field.demandDate') , width: 150, align:'center', notUpdate:true},
          { field: "status", title: this.$i18n.t('field.status'), width: 100 , notUpdate:true},
          { field: "applyBy", title: this.$i18n.t('field.requestAccount'), width: 180 , notUpdate:true},
          { field: "custSapCodeStr", title: this.$i18n.t('field.sortl'),width: 210, notUpdate:true },
          { field: "fae", title: 'INCX FAE' ,width: 140, type:'select'},
          { field: "trainingDate", title: 'Educational Training  Date' ,width: 250, type:'datetimerange' },
          { field: "name", title: 'Educational Training Item',width: 250 ,type:'select', multiple:'true' },
          { field: "remark", title: 'Information',width: 350, type:'textarea',maxlength:'1000'  },
          { field: "faeClosedTimeStr", title: 'FAE case closed' ,width: 200 , checkbox:'true' ,notUpdate:true, tooltip : this.$i18n.t('field.clickConfirm')},
          { field: "closeRemark", title: 'Closed Remark',width: 200, type:'textarea', maxlength:'1000'  },
          { field: "custConfirmTimeStr", title: 'Customer confirmation',width: 220 ,notUpdate:true },
          { field: "fileName", title: 'File',width: 200 ,link:true, type:"file"},
          { title: 'Send mail',width: 150 ,type:"button", buttonName:'send'},
          { field: "sendMail2", title: 'Confirm mail',width: 180 ,notUpdate:true },
          { field: "sendMail3", title: 'Close mail',width: 180 ,notUpdate:true },

        ],
        uploadType:"training" ,
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1 ,
        tableId:'trainingTable',
        exportName: this.$i18n.t('menu.softwareVersion')
      },
      dialogVisible:false,
      dialogTitle:'Educational Training Item Description'    
    };
  }, 
  components: {
    Breadcrumb,
    Table,
    CustomerSearch
  },
  created(){
    this.isCustomer = this.$store.state.auth.user.username.indexOf('@')>-1 ? true : false;     
    this.tableData.columns.forEach((item) => {
        if(item.field == 'name'){
            apiFindSysValueByCategory({ headers: authHeader(), condition: 'TRAINING_ITEM'}).then((response) => {     
              item.selectObj = [];  
              response.data.forEach((rec, index) => {   
                item.selectObj.push({ value: rec.value});
              });             
            });
        }     
      });
  },
  mounted() {  

    apiFindCustIncxWindowsForFae({ headers: authHeader()}).then((response) => { 
      this.faeOpts = [];
      response.data.forEach((item, index) => {   
        this.faeOpts.push({ value: item.value, label: item.value  });
      });
    }).catch((err) => {
      console.log(err);
    });
    this.findData()   
  },
  methods: {
    changeFaeData(row, index, cg){      
 
      if(cg && row.action != 'U'){
        this.loading = true;  
        this.tableData.columns.forEach((item) => {
          if(item.field == 'fae'){
            var sapcode = row.custSapCode.split(' ')[0];     
            item.selectObj = [];        
            apiFindCustIncxWindowsForFaeByCustSapCode({ headers: authHeader(), condition: sapcode}).then((response) => {     
               
              response.data.forEach((rec, index) => {   
                item.selectObj.push({ value: rec.value});
              });      
              this.$refs.tableList.$refs.trainingTable.doLayout();
              this.loading = false;         
            });
          }   
        });        
      }      
    },
    findData(){
      var sdate = '', edate = '';
      if(this.sdate != null && this.sdate != ''){        
        sdate = this.sdate.getFullYear() +''+ CommonUtil.lpad(this.sdate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.sdate.getDate(), 2);
      }
      if(this.edate != null && this.edate != ''){        
        edate = this.edate.getFullYear() +''+ CommonUtil.lpad(this.edate.getMonth()+1, 2) +''+ CommonUtil.lpad(this.edate.getDate(), 2);
      }

      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindTrainingByCondition({ headers: authHeader(), sdate: sdate, edate: edate, condition: this.fae, condition1:this.custSapCode, sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
        
        var reg=new RegExp("<br>","g");
        response.data.forEach((rec, index) => {   
          if(rec.remark != null){
            rec.remark = rec.remark.replace(reg,"\n"); 
          }            
        }); 
        this.tableData.data = response.data;  
        this.tableData.originalTableData =  this.tableData.data;

      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData();
    },
    descOpen(){
      this.dialogVisible = true;
    },
    cancelSave(){
      this.findData();
    },
    saveDoc(data, newFileData){

      if(data.remark != null){
        data.remark = data.remark.replace(/\n|\r\n/g,"<br>");
      }
      
      if(data.length == null){
        data = [data];
      }      
      apiTrainingSave({  headers: authHeader(), datas : data}).then((response) => {                    
        if(response.status == 200){
           this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
          if(typeof newFileData != "undefined") {
            newFileData.docId = response.data;
            if(newFileData.docId!='undefined' && newFileData.docId!=''){
              this.addDataSuccess = true;
              newFileData.subFolder = data[0].custSapCode.split(' ')[0];
              this.$refs.tableList.addFile(newFileData);
            }else{
              this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
              //this.findData();
            }
          }
          this.findData();
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      }).catch((err) => {
        // if(err.response.data.message != null && err.response.data.message != ''){
        //   this.$message.error({message:err.response.data.message, duration: 1000});
        // }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        // }        
        console.log(err);
      });
    },    
    deleteDoc(data){           
      apiTrainingDeleteById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    saveFileSuccess(fileStatus){
      if(this.addDataSuccess && fileStatus){
        this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        this.findData();
      }else{
        this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
      }
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.findData()
    },
    syncSelectCustomer(custNo){            
      this.custSapCode = custNo;
    }, 
    checkAction(row, index, a, field){   
      const msg = this.$i18n.t('msg.trainingFaeClosedConfirm').replace('{item}', row.name);      
      this.$confirm(msg, {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.loading = true;        
        apiFaeClosed({ headers: authHeader(), id:row.id }).then((response) => {    
          if(response.status == 200){
            this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});     
            this.findData();
          }else{
            this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
          }
          this.loading = false;
        }).catch((err) => {
          this.loading = false;
          console.log(err);
        });
        done();
      }).catch(_ => {});   
      
    },
    sendMail(data){
          
      apiSendTrainingMail({  headers: authHeader(), dataId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.sendMailSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.sendMailFail'), duration: 800});
        }
        this.findData();
      }).catch((err) => {
        console.log(err);
      });

    },
    createTraining(){   
      if(this.custSapCode != null && this.custSapCode != ''){
        const msg = this.$i18n.t('msg.createTrainingConfirm');      
        this.$confirm(msg, {
          confirmButtonText: this.$i18n.t('button.confirm'),
          cancelButtonText: this.$i18n.t('button.cancel'),
          type: 'warning'
        }).then(_ => { 
          this.loading = true;        
          apiCreateTraining({ headers: authHeader(), custSapCode:this.custSapCode  }).then((response) => {    
            if(response.status == 200){
              this.$message({ type: "success", message: this.$i18n.t('msg.saveSuccess'), duration: 800});     
              this.findData();
            }else{
              this.$message({ type: "error", message: this.$i18n.t('msg.saveFail'), duration: 800});
            }
            this.loading = false;
          }).catch((err) => {
            this.loading = false;
            console.log(err);
          });
    
          done();
        }).catch(_ => {});   
        
      }else{
        this.$message({ type: "error", message: this.$i18n.t('msg.pleaseSelectCustomerNo'), duration: 800});
      }
    },
        downloadTutorial(){
      this.fullscreenLoading = true;
      var folder = 'cust/other/training/20230220_CTIMS教育訓練SOP_.pdf';
      const getFile = s3.getObject({Bucket: AWSUtil.getAlbumBucketName(), Key: folder}).promise();  

      getFile.then((data) => {   
          this.fullscreenLoading = false;
          const url = window.URL.createObjectURL(new Blob([data.Body]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', '20230220_CTIMS教育訓練SOP_.pdf')
          document.body.appendChild(link)
          link.click()
        }).catch((err) => {   
          this.fullscreenLoading = false;
          return alert("There was an error downloading your file: ", err.message);
        });
    }
  }
};
</script>
